import { Box, Button, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useThemeContext } from '../global/ThemeContext';
import useTranslations from '../global/translation/hooks/translation';
import { designTokens } from '../../theme/designTokens';

const Footer: FC = () => {
  const { darkMode } = useThemeContext();
  const { currentLanguage, translations } = useTranslations();
  const palette = darkMode ? designTokens.colors.dark : designTokens.colors.light;

  const designedByText = translations.other?.designedBy?.[currentLanguage] || 'Designed by';
  const footerText =
    currentLanguage === 'en'
      ? 'Thoughtful horsemanship, private training and family experiences rooted in partnership.'
      : 'Świadome jeździectwo, trening indywidualny i rodzinne doświadczenia oparte na partnerstwie.';

  return (
    <footer style={{ width: '100%' }}>
      <Box
        sx={{
          width: '100%',
          backgroundColor: darkMode ? palette.background.default : palette.primaryDark,
          color: '#FFFFFF',
          px: { xs: 3, md: 6 },
          py: { xs: 5, md: 6 },
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ width: '100%', maxWidth: '1100px' }}>
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} justifyContent="space-between" alignItems={{ xs: 'flex-start', md: 'center' }}>
            <Box sx={{ maxWidth: '560px' }}>
              <Typography
                variant="h5"
                sx={{ color: '#FFFFFF', mb: 1.5 }}
              >
                Urban Equestrian
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.72)', lineHeight: 1.7 }}>
                {footerText}
              </Typography>
            </Box>
            <Button
              href="https://aboe.urbanequestrian.pl/"
              variant="outlined"
              sx={{ borderColor: palette.accent, color: '#FFFFFF', px: 3, '&:hover': { borderColor: '#FFFFFF', bgcolor: 'rgba(255,255,255,0.06)' } }}
            >
              {translations.label.ctaAbeo[currentLanguage]}
            </Button>
          </Stack>
          <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.16)', mt: 4, pt: 2.5 }}>
            <Typography variant="body2" component="span" sx={{ color: 'rgba(255,255,255,0.62)' }} fontWeight={300}>
              © Urban Equestrian {new Date().getFullYear()} · {designedByText}&nbsp;
            </Typography>
            <Typography
              component="a"
              href="https://3dpros.pl/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textDecoration: 'none', color: '#FFFFFF', fontWeight: 700 }}
            >
              3DPros
            </Typography>
          </Box>
        </Box>
      </Box>
    </footer>
  );
};

export default Footer;
